Number.prototype.calcCurrency = function () {
    return this * window.currencyFormat.ex;
};

/*
Format a number as currency based on the current server-side thread culture number format.
This method should yield the same result as "123.32M.ToString("C");" in C#.
*/
Number.prototype.toMoney = function () {
    var n = this, c = window.currencyFormat, i = parseInt(n = Math.abs(+n || 0).toFixed(c.d)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
    return (c.p % 2 ? "" : c.s + (c.p ? " " : "")) + (j ? i.substr(0, j) + c.gs : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + c.gs) + c.ds + Math.abs(n - i).toFixed(c.d).slice(2) + (c.p % 2 ? (c.p == 1 ? "" : " ") + c.s : "");
};